<template>
  <div>
    <apexchart type="pie" :options="options" :series="series" :width="largura"></apexchart>
    {{preencherGrafico}}
  </div>
</template>
<script>
/* eslint-disable */
import VueApexCharts from "vue-apexcharts";
import Dexie from "dexie";
import BibliotecaDeCalculos from "bibliotecadecalculos-f02";
import DadosDespesasAnimais from "../../class/DadosDespesasAnimal.js";
import DadosDasDespesas from "../../class/DadosDasDespesas.js";
import DadosDespesasManutencao from "../../class/DadosDespesasManutencao.js";
import DadosDespesasServicos from "../../class/DadosDespesasServicos.js";
import DadosDasReceitas from "../../class/DadosDasReceitas.js";
import DadosRecursosAnimais from "../../class/DadosRecursosAnimais.js";
import DadosRecursosInstalacoes from "../../class/DadosRecursosInstalacoes.js";
import DadosRecursosMaquinas from "../../class/DadosRecursosMaquinas.js";
import DadosRecursosPastagensOutros from "../../class/DadosRecursosPastagensOutros.js";
import ReceitaAnual from "../../class/ReceitaAnual.js";
import ReceitaAnualAbate from "../../class/ReceitaAnualAbate.js";
import RebanhoDeRecria from "../../class/RebanhoDeRecria.js";
import OutrasReceitas from "../../class/OutrasReceitas.js";
import RebanhoDeReproducao from "../../class/RebanhoDeReproducao.js";

export default {
  components: {
    apexchart: VueApexCharts
  },
  data: () => ({
    options: {
      legend: {
        position: "top"
      },
      colors: ["#BF343F", "#A7E4F2", "#32736C", "#D9B504"],
      labels: [
        "Custo do capital (juros)",
        "Retirada do produtor (pró-labore)",
        "Depreciações",
        "Despesas"
      ],
      dataLabels: {
        enabled: true,
        formatter: function(val) {
          return (
            parseFloat(val.toFixed(2)).toLocaleString("pt-BR", {
              currency: "BRL"
            }) + " %"
          );
        }
      },
      tooltip: {
        y: {
          formatter: function(val) {
            return parseFloat(val).toFixed(2) + " %";
          }
        }
      }
    },
    series: [0, 0, 0, 0],
    largura: "100%",
    comprimento: "200%",
    formulario: "",
    simulation: ""
  }),

  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    preencherGrafico: function() {
      this.$db.simulation
        .get({ code: this.simulation.code }, dado => {
          var manutencao = new DadosDespesasManutencao(dado.dadosManutencao);
          var despesas = new DadosDasDespesas(dado.dadosDasDespesas);
          var servicos = new DadosDespesasServicos(dado.dadosDespesasServicos);
          var despesasAnimais = new DadosDespesasAnimais(
            dado.dadosDespesasAnimal
          );
          var receitas = new DadosDasReceitas(dado.proLabore);
          var pastagens = new DadosRecursosPastagensOutros(
            dado.dadosRecursosPastagensOutros
          );
          var instalacoes = new DadosRecursosInstalacoes(
            dado.dadosRecursosInstalacoes
          );
          var maquinas = new DadosRecursosMaquinas(dado.dadosRecursosMaquinas);
          var recursosAnimais = new DadosRecursosAnimais(
            dado.dadosRecursosAnimais
          );
          var rebanhoReproducao = new RebanhoDeReproducao(
            dado.rebanhoReproducao
          );
          var abate = new ReceitaAnualAbate(dado.bovinoAbate);
          var outro = new ReceitaAnual(dado.bovinoOutro);
          var recria = new RebanhoDeRecria(dado.rebanhoRecria);
          var outrasReceitas = new OutrasReceitas(dado.outrasReceitas);

          var biblioteca = [
            BibliotecaDeCalculos.RecursosPastagens(pastagens),
            BibliotecaDeCalculos.RecursosInstalacoes(instalacoes),
            BibliotecaDeCalculos.RecursosMaquinas(maquinas),
            BibliotecaDeCalculos.RecursosAnimais(recursosAnimais),
            BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao),
            BibliotecaDeCalculos.DespesasAnimais(despesasAnimais),
            BibliotecaDeCalculos.Despesas(despesas),
            BibliotecaDeCalculos.DadosDasReceitas(receitas),
            BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)),
            BibliotecaDeCalculos.DespesasServicos(servicos),
            BibliotecaDeCalculos.RebanhoDeVenda(abate, outro),
            BibliotecaDeCalculos.RebanhoDeRecria(recria),
            BibliotecaDeCalculos.OutrasReceitas(outrasReceitas),
            BibliotecaDeCalculos.CalculosDosGraficos(
              BibliotecaDeCalculos.RecursosPastagens(pastagens),
              BibliotecaDeCalculos.RecursosInstalacoes(instalacoes),
              BibliotecaDeCalculos.RecursosMaquinas(maquinas),
              BibliotecaDeCalculos.RecursosAnimais(recursosAnimais),
              BibliotecaDeCalculos.RebanhoDeReproducao(rebanhoReproducao),
              BibliotecaDeCalculos.DespesasAnimais(despesasAnimais),
              BibliotecaDeCalculos.Despesas(despesas),
              BibliotecaDeCalculos.DadosDasReceitas(receitas),
              BibliotecaDeCalculos.DespesasManutencao(manutencao, BibliotecaDeCalculos.RecursosInstalacoes(instalacoes), BibliotecaDeCalculos.RecursosMaquinas(maquinas)),
              BibliotecaDeCalculos.DespesasServicos(servicos),
              BibliotecaDeCalculos.RebanhoDeVenda(abate, outro),
              BibliotecaDeCalculos.RebanhoDeRecria(recria),
              BibliotecaDeCalculos.OutrasReceitas(outrasReceitas)
            )
          ];

          return biblioteca;
        })
        .then(
          g => (
            (this.series[0] = (g[13].jurosTotais() / g[13].custoTotal()) * 100),
            (this.series[1] =
              (g[7].totalRetirada() / g[13].custoTotal()) * 100),
            (this.series[2] =
              (g[13].totalDepreciacoes() / g[13].custoTotal()) * 100),
            (this.series[3] =
              (g[13].totalDespesas() / g[13].custoTotal()) * 100)
          )
        );
    }
  }
};
</script>
<style scoped>
</style>